import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB4cf7qNizb8kfMd-exuLW74x8UmVu8Hb0",
    authDomain: "tbrinkmann-54d9a.firebaseapp.com",
    projectId: "tbrinkmann-54d9a",
    storageBucket: "tbrinkmann-54d9a.appspot.com",
    messagingSenderId: "193989550442",
    appId: "1:193989550442:web:964dbfbe4c625656d78513",
    measurementId: "G-X2GRQ06HTX"
};
// init firebase
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// init firebase db and auth
const db = getFirestore();
const auth = getAuth()
const storage = getStorage(app);

export { db, auth, storage }